import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import MarkDown from '../components/MarkDown';
import Footer from '../components/Footer';
import '../blog.css';
import {
  DEFAULT_IMAGE,
  extractMarkdownMetadata,
  fetchStaticMarkdown,
} from '../utils/markdownContent';

function Article() {
  const { id } = useParams();
  const [title, setTitle] = useState('記事 - ASMRキリスト教会');
  const [description, setDescription] = useState('ASMRキリスト教会の記事');
  const [image, setImage] = useState(DEFAULT_IMAGE);

  useEffect(() => {
    let isMounted = true;

    const fetchMetadata = async () => {
      try {
        const text = await fetchStaticMarkdown(`/article/${id}`);
        if (!isMounted) {
          return;
        }

        const metadata = extractMarkdownMetadata(text, {
          description: 'ASMRキリスト教会の記事',
        });
        setTitle(metadata.title ? `${metadata.title} - ASMRキリスト教会` : '記事 - ASMRキリスト教会');
        setDescription(metadata.description || 'ASMRキリスト教会の記事');
        setImage(metadata.image || DEFAULT_IMAGE);
      } catch (error) {
        console.error(error);
        if (isMounted) {
          setTitle('記事 - ASMRキリスト教会');
          setDescription('ASMRキリスト教会の記事');
          setImage(DEFAULT_IMAGE);
        }
      }
    };

    fetchMetadata();

    return () => {
      isMounted = false;
    };
  }, [id]);

  return (
    <div>
      <Header
        title={title}
        description={description}
        url={`https://www.asmrchurch.com/article/${id}`}
        image={image}
      />
      <div className="cont2">
        <MarkDown
          articleType="article"
          articleId={id}
          fallbackPath={`/article/${id}`}
        />
        <div className="return" />
        <a href="/article">記事一覧</a>
      </div>
      <Footer />
    </div>
  );
}

export default Article;
